<template>
  <div class="topBar">
    <div class="all_logo">
      <img v-if="showDCL" class="logo" src="static/image/color_logo.png"/>
      <img v-else class="logo" :src="companyLogo"/>
      <!--      <span>T云，让网络营销变简单！</span>-->
      <!-- <el-button size="small" class="btn">极速建站</el-button> -->
      <!-- <a href="https://presiteadmin.71360.com/#/mainIndex/index" target="_blank">网站管理</a> -->
      <!-- <a href="https://presiteadmin.71360.com/#/mainIndex/index" target="_blank">
          <el-button size="small" class="btn">网站管理</el-button>
      </a>-->
      <a :href="website" target="_blank" v-if="showDCL">
        <el-button size="small" class="btn btn-manage">
          <i class="icon-manage"></i>
          <span>{{$t('view_public_topbar_1')}}</span>
        </el-button>
      </a>
      <el-button v-if="$store.state.app.role == 'designer'"
                 class="btn-upload"
                 type="primary"
                 size="small"
                 @click="updoc"
                 v-loading="updoc_loading"
                 style="margin-left: 10px">
        <i class="icon-upload"></i>
        <span>{{$t('view_public_topbar_2')}}</span>
      </el-button>
      <el-button class="btn-translate"
                 type="primary"
                 size="small"
                 @click="translate"
                 v-if="$store.state.app.role == 'designer' && $store.state.app.language == 'en-us'"
                 style="margin-left: 10px">{{$t('view_public_topbar_3')}}</el-button>
      <!-- <el-button type="primary" size="small" @click="translate_page" v-if="
          $store.state.app.language != 'zh-cn'
        "
        style="margin-left: 10px">单页面翻译</el-button> -->
    </div>
    <div class="top_btns">
      <!--      <el-button type="text" @click="Change_pattern('pc')" class="btn" v-if="$store.state.app.view_pattern === 'mb'"-->
      <!--                 :loading="change_pattern_loading">电脑视图-->
      <!--      </el-button>-->
      <!--      <el-button type="text" @click="Change_pattern('mb')" class="btn" v-if="$store.state.app.view_pattern === 'pc'"-->
      <!--                 :loading="change_pattern_loading">手机视图-->
      <!--      </el-button>-->
      <!-- <el-button
        type="text"
        @click="addXysTp"
        class="btn"
        v-if="$store.state.app.view_pattern === 'pc'"
      >加</el-button>

      <el-button
        type="text"
        @click="delXysTemplet"
        class="btn"
        v-if="$store.state.app.view_pattern === 'pc'"
      >删</el-button>-->

      <!--<el-button type="text" @click="Recovery" class="btn" :disabled="Recovery_data != null ? false:true">恢复</el-button>-->
      <!-- <el-button
        type="text"
        @click="open_historical"
        icon="el-icon-document"
        class="btn"
        style="margin-right: 46px;"
      >历史</el-button>-->


      <el-button @click="openReplaceDialog" size="small" style="margin-right: 12px;">{{$t('view_public_topbar_38' /* 内容替换 */)}}</el-button>

      <div class="lang_wrap">
        <LanguageSwitch></LanguageSwitch>
      </div>
      <el-button type="text" @click="god_set" icon="el-icon-s-tools" class="btn" v-if="is_god">{{$t('view_public_topbar_4')}}</el-button>

      <div class="platform">
        <el-button type="text" @click="Change_pattern('pc')">
          <i class="icon_pc one_btn" :class="{ active: $store.state.app.view_pattern === 'pc' }"></i>
        </el-button>

        <div class="separator"></div>

        <el-button type="text" @click="Change_pattern('mb')">
          <i class="icon_mobile one_btn" :class="{ active: $store.state.app.view_pattern === 'mb' }"></i>
        </el-button>
      </div>

      <!-- <el-button class="help_btn" type="text">
        <i class="icon_help"></i>
      </el-button>-->

      <div class="control">
        <el-tooltip :content="$t('view_public_topbar_5')" placement="bottom" effect="light">
          <el-button @click="Revoke" class="historical_record_btn" :disabled="Revoke_data !== null ? false : true"
                     type="text">
            <i class="icon-undo revoke one_btn"></i>
          </el-button>
        </el-tooltip>
        <el-tooltip :content="$t('view_public_topbar_6')" placement="bottom" effect="light">
          <el-button @click="Recovery" class="historical_record_btn" :disabled="Recovery_data !== null ? false : true"
                     type="text">
            <i class="icon-recover recovery one_btn"></i>
          </el-button>
        </el-tooltip>
      </div>
      <div class="top_question">
        <a @click="getHelpDocumentLink" target="_blank">
          <el-tooltip :content="$t('view_public_topbar_7')" placement="bottom" effect="light">
            <el-button type="text">
              <i class="icon-help"></i>
            </el-button>
          </el-tooltip>
        </a>
      </div>

      <div :class="['save_preview', shouldSaveAndCheckBtnShow?'save_preview_long':'']">
        <div v-loading="$store.state.app.save_loading" class="save_btn_frame">
          <el-button class="btn-save"
                     size="small"
                     @click.stop="translate_page(false)" :disabled="!$store.state.app.is_change"
                     :style="{
              background: $store.state.app.save_loading ? '#3D8AFF' : '',
            }">{{$t('view_public_topbar_8')}}</el-button>
        </div>
        <template>
          <el-button v-if="!$store.state.app.is_change"
                     class="btn-preview preview_normal"
                     size="small"
                     @click="preview"
                     :disabled="$store.state.preview.path == ''"><i class="icon-preview"></i><span>{{$t('view_public_topbar_9')}}</span>
          </el-button>
          <div v-else
               class="preview c-preview"
               v-loading="$store.state.app.save_loading">
            <el-button class="preview_default btn-preview" size="small" @click="preview"
                       :disabled="$store.state.preview.path == ''">
              <i class="icon-preview"></i><span>{{$t('view_public_topbar_9')}}</span>
            </el-button>
            <div class="preview_hover">
            <el-button size="small" style="background: #3D8AFF;width: 100%;" @click="translate_page(true)"
                       :disabled="$store.state.preview.path == ''"
                       :style="{
              background: $store.state.app.save_loading ? '#3D8AFF' : '',
            }">{{$t('view_public_topbar_10')}}</el-button>
            </div>
          </div>
        </template>
      </div>
      <el-button class="cancel btn-cancel" size="small" :disabled="!$store.state.app.is_change"
                 @click="discard_changes">{{$t('view_public_topbar_11')}}</el-button>
      <el-button v-if="shouldSaveAndCheckBtnShow"
                 :loading="isSaveAndCheckLoading"
                 class="btn-save-check"
                 size="small"
                 @click="saveAndCheckProhibitedWords">
        <i class="icon-check"></i>
        <span>{{$t('view_public_topbar_12')}}</span>
      </el-button>
    </div>
    <god_set v-if="god_set_isShow" @closed="god_set_isShow = false"></god_set>

    <template v-if="$store.state.app.language != 'zh-cn' && $store.state.app.role == 'designer'">
      <el-dialog :title="$t('view_public_topbar_13')" :visible.sync="translate_dialogVisible" :modal-append-to-body="true"
                 :append-to-body="true"
                 class="translate_dialogVisible">
        <div class="language_list">
          <el-checkbox-group v-model="translate_language">
            <el-checkbox :label="item[0]" v-for="(item,i) in languageList" :key="i">{{ item[0] }}</el-checkbox>
          </el-checkbox-group>

        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="translate_close">{{$t('view_public_topbar_14')}}</el-button>
          <el-button type="primary" @click="translate_save">{{$t('view_public_topbar_15')}}</el-button>
        </span>
      </el-dialog>
    </template>
    <template v-if="show_language">
      <el-dialog v-if="translate_page_dialogVisible" :title="$t('view_public_topbar_16')" width="480px"
                 :visible.sync="translate_page_dialogVisible"
                 :modal-append-to-body="true" :append-to-body="true" class="translate_page_dialogVisible">
        <div class="language_list" style="max-height: 300px;overflow: hidden auto;">
          <p style="margin-bottom: 30px;">{{$t('view_public_topbar_17')}}<p>
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{$t('view_public_topbar_18')}}</el-checkbox>
          <div style="margin: 15px 0;"></div>
          <el-checkbox-group v-model="translate_language" @change="handleCheckedLanguagesChange">
            <el-checkbox :label="i" v-for="(item,i) in languageList" :key="i">{{item[0]}}{{$t('view_public_topbar_19')}}</el-checkbox>
          </el-checkbox-group>
          <p class="translate_banner">
            <el-checkbox :disabled="translate_language.length > 0 ? false : true" v-model="ifBanner" :true-label="1"
                         :false-label="0">{{$t('view_public_topbar_20')}}</el-checkbox>
          </p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="translate_page_close">{{$t('view_public_topbar_14')}}</el-button>
          <el-button type="primary" @click="translate_page_save" :loading='showTranslate'>{{$t('view_public_topbar_15')}}</el-button>
        </span>
      </el-dialog>
    </template>

    <el-dialog
      :title="$t('view_public_topbar_39')"
      width="480px"
      :visible.sync="bannerConfirmVisible"
      :modal-append-to-body="true"
      :append-to-body="true"
      class="banner_confirm_dialog">
      <p style="margin-bottom: 16px; line-height: 24px;">
        {{$t('view_public_topbar_40')}}
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bannerConfirmCancel">{{$t('view_public_topbar_11')}}</el-button>
        <el-button type="primary" @click="bannerConfirmSave" :loading='showTranslate'>{{$t('view_public_topbar_15')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('view_public_topbar_31'/* 指定内容替换 */)"
      custom-class="add_content_dialog"
      :visible.sync="replaceDialogVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      v-loading="replaceDialogloading"
      width="850px">

      <div class="top_operate">
        <div class="alert_cont">
          <i class="icon_warning el-icon-warning-outline"></i>
          <span>{{$t('view_public_topbar_32'/* 提示：内容替换范围包含可视化和管理后台 */)}}</span>
        </div>
        <div class="to_add">
          <el-button @click="addWords" size="mini" type="primary">{{$t('components_add_button_index_1953'/* 新增 */)}}</el-button>
        </div>
      </div>

      <div class="add_words" >
        <div class="add_words_content">
          <el-form ref="dialogForm" :model="formData" :rules="rules" label-position="right" label-width="0px">
          <div v-for="(item, index) in formData.replaceWords" class="add_item" :key="index">
            <el-form-item
              label=""
              :prop="`replaceWords.${index}.from`"
              :rules="rules.from">
              <el-input style="width: 336px;" :placeholder="$t('view_public_topbar_34'/* 请填写关键词 */)" v-model="item.from" :maxlength="200" rows="2" show-word-limit type="textarea"></el-input>
            </el-form-item>

            <span class="rep_w" :class="$store.state.app.language === 'en-us' ? 'lang_en_w' : ''">{{$t('view_public_topbar_36'/* 替换为 */)}}</span>
            <el-form-item>
              <el-input style="width: 336px;" :placeholder="$t('view_public_topbar_35'/* 请填写替换后的关键词 */)" v-model="item.to"  :maxlength="200" rows="2" show-word-limit type="textarea"></el-input>
            </el-form-item>
            <i
              v-if="formData.replaceWords.length > 1"
                class="el-icon-delete selected_del"
                @click="delWords(index)"
              ></i>
          </div>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button  size="medium" type="theme" @click="cancelReplace()" style="width: 88px">{{$t('view_public_topbar_14'/* 取消 */)}}</el-button>
        <el-button :loading="replaceDialogloading" type="primary" size="medium" @click="sureReplace()" style="width: 88px">{{$t('view_public_topbar_15'/* 确定 */)}}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import i18n from '../../language/index'

import request from "@/base/request";
import {
  p_save,
  addXysTp,
  delXysTemplet,
  updoc,
  translate,
  getPlatformInfo,
  getlanguageList,
  getFreeFontList,
  getHomeData,
  saveFontList,
  getHelpLink,
  getReplaceWords,
  saveReplaceWords
} from "@/api/app";
import {getFshopRole} from "../../api/app";
import Cookies from "js-cookie";
import god_set from "@/view/god_set";
import store from "../../vuex/store";
import LanguageSwitch from '@/language/languageSwitch.vue'

export default {
  name: "topBar",
  data() {
    return {
      helpLink: '',
      showTranslate: false,
      showDCL: location.host.indexOf("marketingforce") > -1 ? true : false,
      website: process.env.BASE_WM_Website_Domain,
      themeId: "",
      change_pattern_loading: false,
      updoc_loading: false,
      god_set_isShow: false,
      companyLogo: "",
      is_zhendao: false,
      translate_dialogVisible: false,
      translate_language: [],
      translate_page_dialogVisible: false,
      stepNum: 2,
      checkPageList: [],
      languageList: {},
      languageType: '',
      show_language: false,
      checkAll: false,
      isIndeterminate: false,
      isPreview: false,
      ifBanner: 0,
      bannerConfirmVisible: false,
      isSaveAndCheckLoading: false,
      replaceDialogVisible: false,
      replaceDialogloading: false,
      rules: {
        from: [
          { required: true, message: i18n.t('view_public_topbar_34'/* 请填写关键词 */), trigger: 'blur' },
          { min: 0, max: 200, message: '长度限制200个字符', trigger: 'blur' }
        ]
      },
      formData: {
        replaceWords: [{"from":"","to":""}],
      }
    };
  },
  components: {
    god_set,
    LanguageSwitch
  },
  watch: {
    translate_language: {
      handler(val) {
        if (val.length == 0) {
          this.ifBanner = 0
        }
      },
      deep: true
    }
  },
  methods: {

    // 匹配替换
    async openReplaceDialog(){
        const res = await getReplaceWords()
        if(res.code == 200 && res.data && res.data.length > 0){
          this.formData.replaceWords = res.data
        }else{
          this.formData.replaceWords =[{from:'', to:''}]
        }
        this.replaceDialogVisible = true
    },
    cancelReplace(){
      this.replaceDialogVisible = false
    },
    sureReplace(){
      this.replaceDialogloading = true
      let tag = true;
      this.$refs['dialogForm'].validate(valid => {
        tag = valid;
      })
      if(!tag){
        this.replaceDialogloading = false
        this.$nextTick(() => {
          let isError = document.getElementsByClassName("is-error");
          if (isError.length > 0) {
            isError[0].scrollIntoView({
              block: "center",
              behavior: "smooth",
            });
            return false;
          }
        });

        return;
      }
      saveReplaceWords(this.formData.replaceWords).then((res)=>{
        if(res.code==200){
          this.$message.success('保存成功，请手动刷新页面');
          this.replaceDialogVisible = false
          this.replaceDialogloading = false
        }else{
          this.replaceDialogloading = false
          this.$message.error(res.message ? res.message : '提交失败!');
        }
      })
    },
    addWords(){
      if(this.formData.replaceWords.length >= 100){
        this.$message.error('最高支持创建100个替换规则')
        return false
      }
      this.formData.replaceWords.push({from:'', to:''})
    },
    delWords(index){
      this.formData.replaceWords.splice(index, 1);
    },

    getHelpDocumentLink() {
      getHelpLink({id: 73}).then(res => {
        if(res.code == 200 && res.data.producturl) {
          this.helpLink = res.data.producturl
          window.open(this.helpLink, '_blank');
        }
      })
    },
    handleCheckAllChange(val) {
      let temp = []
      for (let key in this.languageList) {
        temp.push(key)
      }
      this.translate_language = val ? temp : [];
      this.isIndeterminate = false;
    },
    handleCheckedLanguagesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === Object.keys(this.languageList).length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < Object.keys(this.languageList).length;
    },
    getHomeData() {
      let languageType = ''
      getHomeData().then(res => {
        languageType = res.data.language
        getlanguageList().then(e => {
          if (e.code === 200) {
            if (e.data[languageType]) {
              delete e.data[languageType]
            }
            this.languageList = e.data
            if (JSON.stringify(this.languageList) !== '{}' && res.data.language == res.data.language_main && res.data.role == 'customer') {
              this.show_language = true
            }
            this.$store.commit("app/set_languageList", e.data);
          }
        })
      })
    },
    //是否有产品销售信息权益
    getFshopStatusInfo(){
      getFshopRole().then(res => {
        if (res.code === 200){
          this.$store.commit("app/SET_PRODUCT_FSHOP", res.data);
        }
      })
    },
    getFreeFontList(){
      let pageName = this.$store.state.app.now_page;
      getFreeFontList({ pageName }).then(res => {
        if(res.code == 200 && res.data){
          let fontList = res.data.map(item => {
            return {
              name: item.fontFamily,
              url: item.fontSrc
            }
          })
          this.$utils.insertStyle(fontList)
        }
      })
    },
    getSysFontList(){
      const sysFontList = {
        "Arial": "https://staticcss.71360.com/pre/static/txys-001/assets/font/wm/system/arial.ttf",
        "Tahoma": "https://staticcss.71360.com/pre/static/txys-001/assets/font/wm/system/tahoma.ttf",
        "impact": "https://staticcss.71360.com/pre/static/txys-001/assets/font/wm/system/impact.ttf",
        "Arial Serif": "https://staticcss.71360.com/pre/static/txys-001/assets/font/wm/system/ARIALBD.TTF",
        "Times New Roman": "https://staticcss.71360.com/pre/static/txys-001/assets/font/wm/system/times.ttf",
        "Georgia": "https://staticcss.71360.com/pre/static/txys-001/assets/font/wm/system/georgia.ttf",
        "Garamond": "https://staticcss.71360.com/pre/static/txys-001/assets/font/wm/system/GARA.TTF",
        "andale mono": "https://staticcss.71360.com/pre/static/txys-001/assets/font/wm/system/ANDALEMO.TTF",
        "arial black": "https://staticcss.71360.com/pre/static/txys-001/assets/font/wm/system/ariblk.ttf",
        "comic sans ms": "https://staticcss.71360.com/pre/static/txys-001/assets/font/wm/system/comic.ttf"
      }
      for (let key in sysFontList) {
        if (!this.isSupportFontFamily(key)) {
          this.$utils.insertStyle({ name: key, url: sysFontList[key] })
        }
      }
    },
    isSupportFontFamily() {
      if (typeof f != "string") {
        return false
      }
      var h = "Arial";
      if (f.toLowerCase() == h.toLowerCase()) {
        return true
      }
      var e = "a";
      var d = 100;
      var a = 100,
        i = 100;
      var c = document.createElement("canvas");
      var b = c.getContext("2d");
      c.width = a;
      c.height = i;
      b.textAlign = "center";
      b.fillStyle = "black";
      b.textBaseline = "middle";
      var g = function (j) {
        b.clearRect(0, 0, a, i);
        b.font = d + "px " + j + ", " + h;
        b.fillText(e, a / 2, i / 2);
        var k = b.getImageData(0, 0, a, i).data;
        return [].slice.call(k).filter(function (l) {
          return l != 0
        })
      };
      return g(h).join("") !== g(f).join("")
    },
    getPlatformInfo() {
      getPlatformInfo().then((res) => {
        if (res.code === 200) {
          this.companyLogo = res.data.companyLogo;
        }
      });
    },
    getFormById(formId) {
      let form = {};
      const list = this.$store.state.app.formList.filter((item, index) => {
        return item.id === formId;
      });
      if (list.length > 0) {
        form = list[0];
      }
      return form;
    },
    saveForm() {
      let obj = this.$store.state.app.se_form_id;
      for (let key in obj) {
        if (obj[key] !== "") {
          let form = this.getFormById(obj[key]);
          if (typeof form.id !== "undefined") {
            this.templet.addForm(form);
          }
        }
      }
      this.templet.getFormList();
    },
    save() {
      this.translate_page()
    },
    Change_pattern(val) {
      if (val === this.$store.state.app.view_pattern) {
        return;
      }
      if(this.$store.state.app.view_pattern == 'pc') {
        this.templet.resetPictureWidth()
      }
      this.change_pattern_loading = true;
      this.$store.commit("app/Change_pattern", val);
      if (val == "pc") {
        this.$store.commit("app/set_screenWidth", $(window).width());
      } else {
        this.$store.commit("app/set_screenWidth", 375);
      }

      //重新渲染横幅的swiper
      this.reset_banner();

      //保存cookie
      Cookies.set("view_pattern_wm", val);

      //关闭一切弹窗
      this.templet.row_edit_close();
      this.templet.dialog_close();

      //排序打开
      if (this.$store.state.app.view_pattern === "mb") {
        $(".layout_column").find(".sort_modules").sortable({
          disabled: true
        });
      } else {
        $(".layout_column").find(".sort_modules").sortable({
          disabled: false
        });
      }

      this.$nextTick(() => {
        //this.templet.fixed_reset();
      });
    },
    reset_banner() {
      this.$store.state.full_screen_banner.isRender = false;
      const timer = setTimeout(() => {
        this.$store.state.full_screen_banner.isRender = true;
        this.templet.all_banner_render("basic_banner");
        this.templet.all_banner_render("basic_list_photos");
        this.templet.all_banner_render("basic_atlas_catalog");
        this.templet.all_banner_render("basic_pro_display");
        this.templet.all_banner_render("basic_article_list");
        clearTimeout(timer);
        this.change_pattern_loading = false;
      }, 500);
    },
    addXysTp() {
      const code = 60000 + Math.floor(Math.random() * 9000) + 1000;
      addXysTp({
        theme_id: code,
      }).then((e) => {
      });
    },

    preview() {
      // 暂时修改为新窗口打开预览
      // var newTab = window.open('about:blank');
      // newTab.location.href = this.$store.state.preview.path;
      //关闭一切弹窗

      this.templet.row_edit_close();
      this.templet.dialog_close();
      this.$store.commit("preview/SET_isShow", true);
      this.setPreviewPath()

    },
    setPreviewPath() {
      this.$store.commit(
        "preview/SET_select",
        this.$store.state.app.view_pattern
      );
      //if (this.$store.state.myRender.common.previewModule === 'new') return window.open(this.$store.state.preview.path)

      //开发环境下的预览
      if (process.env.NODE_ENV === "development") {
        const my_config = require("../../../config/index");
        let path = "";
        if (this.$store.state.app.now_page == "index") {
          path = my_config.dev.preview_path;
        } else {
          const page_name = this.$store.state.preview.path
            .replace("http://", "")
            .split("/")[1];
          path = my_config.dev.preview_path + page_name;
        }
        this.$store.commit("preview/SET_path", path);
      }
    },
    open_historical() {
      this.$store.commit("historical/websql_open");
    },
    Revoke() {
      this.templet.implement_Revoke();
    },
    Recovery() {
      this.templet.implement_Recovery();
    },
    discard_changes() {
      this.$confirm(i18n.t('view_public_topbar_22'), i18n.t('view_public_topbar_23'), {
        confirmButtonText: i18n.t('view_public_topbar_24'),
        cancelButtonText: i18n.t('view_public_topbar_11'),
        center: true,
        // customClass: "del_dialog",
        appendToBody: true,
        customClass: 'language_confirm_' + this.$store.state.app.web_language_wm
      })
        .then((e) => {
          this.templet.p_init();
        })
        .catch(() => {
        });
    },

    //保存并预览
    save_and_preview() {
      this.templet.p_save(this.preview);
      // 保存表单
      this.templet.saveChangeForm();
    },
    //上传
    updoc() {
      this.updoc_loading = true;
      updoc()
        .then((e) => {
          if (e.code == 200) {
            this.$message.success({
              showClose: true,
              message: i18n.t('view_public_topbar_25'),
            });
          } else {
            this.$message.error({
              showClose: true,
              message: e.message,
            });
          }
        })
        .catch(() => {
          this.$message.error({
            showClose: true,
            message: e.message,
          });
        })
        .finally(() => {
          this.updoc_loading = false;
        });
    },
    // 翻译
    translate() {
      // this.translate_dialogVisible = true
      let loading = this.$loading({
        lock: true,
        text: i18n.t('view_public_topbar_26'),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      translate()
        .then((res) => {
          if (res.code === 200) {
            this.$message.success(res.message);
            window.location.reload();
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    translate_page_to_next() {
      if (this.checkPageList.length === 0) {
        this.$message.error(i18n.t('view_public_topbar_27'))
        return
      }
      this.stepNum = 2
    },
    saveAndCheckProhibitedWords() {
      this.isSaveAndCheckLoading = true
      let previewWindow = this.openProhibitedWordsPreviewPage()
      this.saveFont()
      if (this.show_language) {
        this.translate_page_dialogVisible = true
      } else {
        this.templet.p_save(() => {
          this.setPreviewPath()
          previewWindow.location.href = this.$store.state.preview.path + '?prohibited_words=1'
          this.isSaveAndCheckLoading = false
        });
        // 保存表单
        this.templet.saveChangeForm();
      }
    },
    openProhibitedWordsPreviewPage() {
      return window.open('about:blank')
    },
    //单页面翻译
    translate_page(isPreview) {
      this.isPreview = isPreview
      this.saveFont()
      if (this.show_language) {
        this.translate_page_dialogVisible = true
      } else {
        if (this.isPreview) {
          this.save_and_preview()
        } else {
          this.templet.implement_save();
        }
      }
    },
    translate_page_close() {
      this.translate_language = []
      this.checkAll = false
      this.isIndeterminate = false
      this.translate_page_dialogVisible = false
    },
    translate_page_save() {
      this.$store.commit('app/set_translate_language', this.translate_language)
      this.$store.commit('app/set_isTranslateBanner', this.ifBanner)
      if (this.ifBanner === 1) {
        this.bannerConfirmVisible = true
        return
      }
      this.do_translate_page_save()
    },
    bannerConfirmCancel() {
      this.bannerConfirmVisible = false
    },
    bannerConfirmSave() {
      this.bannerConfirmVisible = false
      this.do_translate_page_save()
    },
    do_translate_page_save() {
      if (this.isPreview) {
        this.save_and_preview()
      } else {
        this.templet.implement_save();
      }
      this.showTranslate = false
      this.translate_page_close()
    },
    delXysTemplet() {
      delXysTemplet({
        id: 30,
      });
    },
    god_set() {
      this.god_set_isShow = true;
    },
    translate_save() {

    },
    translate_close() {
      this.translate_dialogVisible = false
    },
    clearData() {
      this.stepNum = 2
      this.checkPageList = []
      this.translate_language = []
      this.translate_dialogVisible = false
      this.translate_page_dialogVisible = false

      this.$store.commit('app/set_show_translate', false);
    },
    saveFont() {
      let fontData = this.templet.getPageFontData()
      fontData.pageName = this.$store.state.app.now_page
      saveFontList(fontData)
    },
  },
  created() {
    // this.getHelpDocumentLink()
  },
  computed: {
    topBarVisible() {
      return this.$store.state.app.topBarVisible
    },
    Revoke_data() {
      return this.$store.getters["historical/Revoke_data"];
    },
    Recovery_data() {
      return this.$store.getters["historical/Recovery_data"];
    },
    pages() {
      return this.$store.state.app.pages
    },
    is_god() {
      const is_god = Cookies.get("is_god_wm");
      if (is_god) {
        return true;
      } else {
        return false;
      }
    },
    isFullPage() {
      return this.$store.state.app.scrollType !== 'normal'
    },
    shouldSaveAndCheckBtnShow() {
      return this.$store.state.app.language == 'zh-cn'
    },
  },
  mounted() {
    // this.globalResizeWidth(() => {
    //   console.log('123456')

    //   const module = document.body.clientWidth > 770 ? 'pc' : 'mb'
    //   this.Change_pattern(module)
    //   this.templet.row_edit_close();
    //   this.templet.dialog_close();
    //   this.templet.main_dialog_reset();
    // })
    if (location.host.indexOf("dongchali") > -1) {
      this.getPlatformInfo();
    }
    this.getFshopStatusInfo();
    this.getHomeData()
    this.getFreeFontList()
    this.getSysFontList()
    $(window).resize(() => {
      const zoom = window.devicePixelRatio;//获取浏览器缩放比例

      let view_pattern = this.$store.state.app.view_pattern;

      //手机模式下部改变
      if (view_pattern == 'pc') {
        const module = document.body.clientWidth < 760 ? "mb" : "pc";
        this.Change_pattern(module);
      }

      this.templet.row_edit_close();
      this.templet.dialog_close();
      this.templet.main_dialog_reset();

    });
    if (this.$route.query.view_pattern && (this.$route.query.view_pattern == 'mb' || this.$route.query.view_pattern == 'pc')) {
      this.Change_pattern(this.$route.query.view_pattern);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/css/global-variable.scss";

.topBar {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 26px;
  width: 100%;
  height: $topBar-height;
  background: #fff;
  z-index: 2000;
  box-shadow: 0 3px 5px 1px rgba(0, 0, 0, 0.1);
  transition: height .5s, line-height .5s, top .3s, box-shadow .3s;

  .all_logo {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    height: $topBar-height;

    .logo {
      margin-right: 20px;
      width: 43px;
    }
  }

  .btn-upload, .btn-manage {
    background: #fff;
    color: #3D3F42;
    border: 0;
    padding-top: 0;
    padding-bottom: 0;
    height: 30px;
    line-height: 30px;

    .icon-upload, .icon-manage {
      display: inline-block;
      width: 14px;
      height: 14px;
      vertical-align: middle;
      margin-right: 2px;
      background-size: 100% 100%;
      background-repeat: no-repeat;

    }

    .icon-upload {
      background-image: url("/static/image/topbar/icon-upload-gray@2x.png");
    }

    .icon-manage {
      background-image: url("/static/image/topbar/icon-setting-gray@2x.png");
    }

    span {
      vertical-align: middle;
    }

    &:hover {
      background: rgba(61, 138, 255, 0.1) !important;
      color: #3D8AFF !important;

      .icon-upload {
        background-image: url("/static/image/topbar/icon-upload-blue@2x.png");
      }

      .icon-manage {
        background-image: url("/static/image/topbar/icon-setting-blue@2x.png");
      }
    }
  }

  .top_btns {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    height: $topBar-height;

    .lang_wrap {
      width: 140px;
      margin-right: 20px;
    }

    .platform {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      margin-right: 46px;

      .one_btn {
        display: block;
        width: 32px;
        height: 32px;
        background-size: 100% 100%;

        &.icon_pc {
          background-image: url("/static/image/topbar/icon-pc@2x.png");

          &.active {
            background-image: url("/static/image/topbar/icon-pc-blue@2x.png");
          }

          &:hover {
            background-image: url("/static/image/topbar/icon-pc-blue@2x.png");
            //background-position: -127px -69px;
          }
        }

        &.icon_mobile {
          background-image: url("/static/image/topbar/icon-mb@2x.png");

          &.active {
            background-image: url("/static/image/topbar/icon-mb-blue@2x.png");
          }

          &:hover {
            background-image: url("/static/image/topbar/icon-mb-blue@2x.png");
          }
        }
      }

      .separator {
        margin: 0 16px;
        width: 1px;
        height: 16px;
        background: #d1d1d1;
      }
    }

    .icon-help {
      display: inline-block;
      width: 24px;
      height: 24px;
      background-size: 100% 100%;
      background-image: url("/static/image/topbar/icon-help@2x.png");
    }

    .help_btn {
      margin-right: 46px;

      .icon_help {
        display: block;
        width: 26px;
        height: 26px;
        background: url(~@/assets/image/cssSprite.png) no-repeat -183px -114px;

        &:hover {
          background-position: -183px -69px;
        }
      }
    }

    .control {
      margin-right: 20px;
      min-width: 68px;

      .historical_record_btn {
        .one_btn {
          display: block;
          width: 24px;
          height: 24px;
          background-size: 100% 100%;
          background-repeat: no-repeat;

          &.revoke {
            background-image: url("/static/image/topbar/icon-undo-active@2x.png");

            &:hover {
              background-image: url("/static/image/topbar/icon-undo-active@2x.png");
            }
          }

          &.recovery {
            background-image: url("/static/image/topbar/icon-recover-active@2x.png");

            &:hover {
              background-image: url("/static/image/topbar/icon-recover-active@2x.png");
            }
          }
        }

        &[disabled="disabled"] {
          .one_btn {
            &.revoke {
              background-image: url("/static/image/topbar/icon-undo@2x.png");

              &:hover {
                background-image: url("/static/image/topbar/icon-undo@2x.png");
              }
            }

            &.recovery {
              background-image: url("/static/image/topbar/icon-recover@2x.png");

              &:hover {
                background-image: url("/static/image/topbar/icon-recover@2x.png");
              }
            }
          }
        }
      }
    }

    .save_preview {
      position: relative;
      // min-width: 155px;
      display: flex;
      font-size: 0;

      &.save_preview_long {
        //min-width: 360px;
      }

      /deep/ .el-loading-mask {
        transform: scale(0.6);
        background: #3D8AFF;
        z-index: 98;

        .el-loading-spinner {
          .path {
            stroke: #fff;
            stroke-width: 3px;
          }
        }
      }

      .save_btn_frame {
        display: inline-block;
        margin-right: 10px;
      }

      .preview_normal {
        margin-left: 10px;
      }

      .preview {
        margin-left: 0;
        z-index: 99;
        transition: all 0.2s;
        top: 0;

        /deep/ .el-loading-mask {
          display: none;
        }

        &:hover {
          left: 0;
        }

        &:hover /deep/ .el-loading-mask {
          display: block;
        }

        .preview_hover {
          margin-left: 0;
          background: #3d8aff !important;
          overflow: hidden;
          border-radius: 3px;
        }

        .preview_default {
          width: 100%;
          margin-left: 0;
        }

        &:hover .preview_default {
        }

        &:hover .preview_hover {
          width: 100% !important;
        }

        &.c-preview {
          width: auto;
          left: 0;
          .preview_hover {
            transition: right 0.2s, width 0.2s;
            position: absolute;
            width: 0;
            right: 0;
            top: 0;
          }
        }
      }

      .btn-preview, .preview_default {
        padding-top: 0px;
        padding-bottom: 0px;
        height: 30px;
        line-height: 30px;
        padding-left: 14px;

        .icon-preview {
          display: inline-block;
          width: 16px;
          height: 16px;
          vertical-align: middle;
          background-image: url("/static/image/topbar/icon-preview-gray@2x.png");
          background-size: 100% 100%;
          margin-right: 3px;
        }

        &:hover {
          .icon-preview {
            background-image: url("/static/image/topbar/icon-preview-white@2x.png");
          }
        }
      }

      .preview_default {

      }

      .cancel {
        margin-left: 10px;
      }

      .btn-save-check {
        padding-top: 0;
        padding-bottom: 0;
        height: 30px;
        line-height: 30px;

        .icon-check {
          display: inline-block;
          width: 16px;
          height: 16px;
          vertical-align: middle;
          background-size: 100% 100%;
          background-image: url("/static/image/topbar/icon-check-gray@2x.png");
        }

        &:hover {
          background: #ff5d5d;
          border-color: #ff5d5d;

          .icon-check {
            background-image: url("/static/image/topbar/icon-check-white@2x.png");
          }
        }
      }

      .btn-save-check {

      }
    }
  }
}

.topBar {
  .btn-preview.el-button, .btn-upload.el-button, .btn-upload.el-button.el-button--primary, .btn-save-check.el-button, .btn-save.el-button, .btn-cancel.el-button, .btn-translate.el-button, .btn-save.el-button, .btn-cancel.el-button {
    padding-top: 0;
    padding-bottom: 0;
    height: 30px;
    line-height: 30px;
    border-color: transparent;
    background: rgba(61, 63, 66, 0.05);
    color: #3D3F42;


    &.is-disabled {
      background: rgba(61, 63, 66, 0.025);
      color: #999;
    }

    &.is-disabled:hover {
      background: rgba(61, 63, 66, 0.025);
      color: #999;
    }

    &:hover {
      background: #3D8AFF;
      color: #fff;
    }
  }

  .btn-save.el-button {
    //margin-left: 10px;
  }

  .btn-save.el-button {
    background: #3D8AFF;
    color: #fff;
  }
}

// 图标的白边导致没对齐
.icon_pc {
  position: relative;
  top: -1px;
}

.icon-preview {
  position: relative;
  top: -1px;
}

.icon-check {
  position: relative;
  top: -2px;
}

.topBar .top_btns .save_preview .preview {
  //left: 90px;
}

// 动效

.save_preview {
  margin-right: 10px;
}

.btn-save-check, .btn-cancel {
  float: right;
}

//hover的时候，背景图片第一次加载需要时间，不会马上显示出来，看上去会闪烁一下，用户体验不好，放在伪元素里让它预先加载一次
.icon-manage, .icon-upload, .icon_pc, .icon_mobile, .icon-undo, .icon-recover, .icon-preview, .icon-check {
  &:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
  }
}

.icon-manage:after {
  background-image: url("/static/image/topbar/icon-setting-blue@2x.png");
}

.icon-upload:after {
  background-image: url("/static/image/topbar/icon-upload-blue@2x.png");
}

.icon_pc:after {
  background-image: url("/static/image/topbar/icon-pc-blue@2x.png");
}

.icon_mobile:after {
  background-image: url("/static/image/topbar/icon-mb-blue@2x.png");
}

.icon-undo:after {
  background-image: url("/static/image/topbar/icon-undo-active@2x.png");

}

.icon-recover:after {
  background-image: url("/static/image/topbar/icon-recover@2x.png");
}

.icon-preview:after {
  background-image: url("/static/image/topbar/icon-preview-white@2x.png");
}

.icon-check:after {
  background-image: url("/static/image/topbar/icon-check-white@2x.png");
}


.translate_page_dialogVisible {
  .page_list {
    max-height: 250px;
    overflow-x: hidden;
    overflow-y: visible;
  }

  /deep/ .el-checkbox {
    width: 25%;

    .el-checkbox__label {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: middle;
    }
  }

  /deep/ .el-radio {
    width: 19%;

    .el-radio__label {
      display: inline-block;
      padding-left: 10px;
      line-height: 21px;
      width: 85%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: middle;
    }
  }

  .translate_banner {
    /deep/ .el-checkbox {
      width: 100%;
    }

    .tips {
      color: #999;
      padding-left: 24px;
      font-size: 12px;
    }
  }

}

.add_content_dialog{
  .top_operate{
    display: flex;
    justify-content: space-between;
    .alert_cont{
      line-height: 1;
      display: flex;
      align-items: center;
      .icon_warning{
        font-size: 16px;
        margin-right: 4px;
      }
    }
  }
  .add_words_content {
    height: 350px;
    overflow-y: auto;
  }

  .add_words{
    .to_add{
      text-align: right;
    }
    padding-top: 16px;
    .add_item{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 16px;
      margin-right: 8px;
      .rep_w{
        min-width: 45px;
        text-align: center;
        margin: 0px 6px;
        &.lang_en_w{
          min-width: 84px;
        }
      }
      .selected_del{
        margin-left: 8px;
        cursor: pointer;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/view/public/topBar.vue